// Import Vue core modules
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Import UI Framework Module
import vuetify from './plugins/vuetify'

// Import libraries & Modules
import api from '@/apis'

const app = createApp(App)
app.config.warnHandler = function (msg, vm, trace) {
  return (msg, vm, trace)
}
app.use(router).use(store).use(vuetify).provide('$api', { value: api })
app.mount('#app')
